import gql from 'graphql-tag';

import { RosterIdentityBaseDetails } from '../../../../../graphql/fragments/roster-identity';
import { UserDetails } from '../../../../../graphql/fragments/account';

export const AccountRosterIdentities = gql`
  query accountRosterIdentities(
    $limit: Int = 100
    $offset: Int = 0
    $search_query: String
    $album_folder_ids: [RecordID] = []
    $contact_link_album_folder_ids: [RecordID] = []
    $album_ids: [RecordID] = []
    $contact_link_album_ids: [RecordID] = []
  ) {
    me {
      id
      roster_identities(
        slice: { limit: $limit, offset: $offset }
        search_query: $search_query
        include_album_folder_albums: true
        album_folder_ids: $album_folder_ids
        contact_link_album_folder_ids: $contact_link_album_folder_ids
        album_ids: $album_ids
        contact_link_album_ids: $contact_link_album_ids
      ) {
        total
        records {
          id
          ...RosterIdentityBaseDetails
        }
      }
      custom_print_tiers {
        total
      }
    }
  }
  ${RosterIdentityBaseDetails}
  ${UserDetails}
`;
